// components/ExperienceDetails.jsx - 经历详情面板
import React, { useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export function ExperienceDetails({ experience, projects, onClose }) {
  // 所有Hook都放在组件最顶层
  
  // 提取标签
  const expSkills = useMemo(() => {
    if (!experience || !experience.skills) return [];
    return Array.isArray(experience.skills) ? experience.skills : [];
  }, [experience]);
  
  // 处理内容中的标签行
  const processedContent = useMemo(() => {
    if (!experience || !experience.content) return '';
    // 移除标签行
    return experience.content.replace(/^(#[\w\u4e00-\u9fa5_-]+\s*)+$/gm, '');
  }, [experience]);
  
  console.log("Rendering details for:", experience); // 添加调试日志
  if (!experience) return null;
  
  // 计算职业时长
  const getDuration = () => {
    const start = new Date(experience.startDate);
    const end = experience.endDate ? new Date(experience.endDate) : new Date();
    const months = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
    const years = Math.floor(months / 12);
    const remainingMonths = months % 12;
    
    return years > 0 
      ? `${years}年${remainingMonths > 0 ? remainingMonths + '个月' : ''}`
      : `${remainingMonths}个月`;
  };
  
  return (
    <div className="experience-details">
      <div className="details-header" style={{ backgroundColor: experience.color + '22', borderColor: experience.color }}>
        <h2>{experience.company}</h2>
        <button className="close-button" onClick={onClose}>×</button>
      </div>
      
      <div className="details-content">
        <div className="details-summary">
          <h3>{experience.title}</h3>
          <p className="duration">
            {new Date(experience.startDate).toLocaleDateString()} — 
            {experience.endDate ? new Date(experience.endDate).toLocaleDateString() : '至今'}
            （{getDuration()}）
          </p>
          <p className="location">{experience.location}</p>
        </div>
        
        <div className="details-description">
          {experience.content ? (
            <ReactMarkdown 
              remarkPlugins={[remarkGfm]}
              components={{
                // 改进图片渲染逻辑
                img: ({node, ...props}) => {
                  // 解析图片URL，修复路径问题
                  let imgSrc = props.src;
                  if (imgSrc && imgSrc.startsWith('/public/')) {
                    // 移除/public/前缀，因为在浏览器中访问时不需要这个前缀
                    imgSrc = imgSrc.substring(7);
                  }
                  
                  return <img src={imgSrc} alt={props.alt || '经历图片'} style={{maxWidth: '100%'}} />
                },
                // 跳过一级标题，因为它已经被用作经历标题
                h1: () => null,
                // 过滤包含标签的段落
                p: ({node, ...props}) => {
                  // 检查该段落是否只包含标签
                  const content = props.children?.toString() || '';
                  if (content.trim().startsWith('#') && content.includes('#')) {
                    // 如果是标签行，则不显示
                    return null;
                  }
                  return <p {...props} />
                }
              }}
            >
              {processedContent}
            </ReactMarkdown>
          ) : (
            <>
              <h4>工作职责</h4>
              <ul>
                {experience.responsibilities.map((resp, index) => (
                  <li key={index}>{resp}</li>
                ))}
              </ul>
              
              <h4>成就和影响</h4>
              <ul>
                {experience.achievements.map((achievement, index) => (
                  <li key={index}>{achievement}</li>
                ))}
              </ul>
            </>
          )}
          
          {/* 标签显示区域 */}
          {expSkills.length > 0 && (
            <div className="exp-skills-section">
              <div className="skills-container">
                {expSkills.map((skill, index) => (
                  <span key={index} className="skill-tag">{skill}</span>
                ))}
              </div>
            </div>
          )}
        </div>
        
        {projects.length > 0 && (
          <div className="projects-section">
            <h4>相关项目</h4>
            <div className="projects-grid">
              {projects.map(project => (
                <div key={project.id} className="project-card" style={{ borderColor: project.color || experience.color }}>
                  <h5>{project.name}</h5>
                  <p>{project.description}</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}